import React, { useState } from 'react';
import { Link } from 'react-scroll'
import './Navbar.css'

const Navbar = () => {
    const [navbar, setNavbar] = useState(false)
    const changeBackground = () => {
        if (window.scrollY >= 100) {
            setNavbar(true)
        } else {
            setNavbar(false)
        }
    }
    window.addEventListener('scroll', changeBackground)
    return (
        <navbar className={navbar ? 'navbar scroll' : 'navbar'}>
            <p>Logo</p>
            <ul className='navMenu' >
                <li className='navItem'>
                    <Link to="header" spy={true} smooth={true} offset={-100} duration={500}>HOME</Link>
                </li>
                <li className='navItem'>
                    <Link to="about" spy={true} smooth={true} offset={-100} duration={500}>ABOUT</Link>
                </li>
                <li className='navItem'>
                    <Link to="service" spy={true} smooth={true} offset={-100} duration={500}>SERVICE</Link>
                </li>
                <li className='navItem'>
                    <Link to="portfolio" spy={true} smooth={true} offset={-100} duration={500}>WORK</Link>
                </li>
                <li className='navItem'>
                    <Link to="contact" spy={true} smooth={true} offset={-100} duration={500}>CONTACT</Link>
                </li>
            </ul>
        </navbar>
    );
};

export default Navbar;